import { createRouteSectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

export const ADVERSE_EVENTS_SECTION_RESOURCES = createRouteSectionResources({
	route: '/mocra/adverse-events',
})
